export class IncomeAssertVerification {
  sType: string;
  sContact: string;
  sIdentifier: string;
}
